import TriangleDown from './triangle-down';

export * from './triangle-down';
export default TriangleDown;
